export default function getSearchLabel() {
    return $('#search_label').text().trim();
}
